module.exports = __webpack_public_path__ + "img/dawson-street.df312816.png";